declare namespace $ {

	type $bog_theme_auto__theme_light_bog_blitz_blog_1 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_theme_auto['theme_light'] >
	>
	type $bog_theme_auto__theme_dark_bog_blitz_blog_2 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_theme_auto['theme_dark'] >
	>
	type $bog_theme_auto__themes_bog_blitz_blog_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $bog_theme_auto['themes'] >
	>
	type $mol_view__sub_bog_blitz_blog_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_blitz_blog_menu__items_bog_blitz_blog_5 = $mol_type_enforce<
		({ 
			'about': string,
			'guide': string,
			'features': string,
			'collab': string,
		}) 
		,
		ReturnType< $bog_blitz_blog_menu['items'] >
	>
	type $bog_blitz_blog_menu__page_bog_blitz_blog_6 = $mol_type_enforce<
		ReturnType< $bog_blitz_blog['page'] >
		,
		ReturnType< $bog_blitz_blog_menu['page'] >
	>
	type $bog_blitz_blog_page__slug_bog_blitz_blog_7 = $mol_type_enforce<
		ReturnType< $bog_blitz_blog['page_slug'] >
		,
		ReturnType< $bog_blitz_blog_page['slug'] >
	>
	type $mol_link__arg_bog_blitz_blog_8 = $mol_type_enforce<
		({ 
			'screen': any,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__title_bog_blitz_blog_9 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__uri_bog_blitz_blog_10 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['uri'] >
	>
	export class $bog_blitz_blog extends $mol_book2 {
		blog_pages( ): readonly(any)[]
		page( next?: string ): string
		page_slug( id: any): string
		Theme( ): $bog_theme_auto
		title( ): string
		Placeholder( ): $mol_view
		pages( ): ReturnType< $bog_blitz_blog['blog_pages'] >
		Menu( ): $bog_blitz_blog_menu
		Page( id: any): $bog_blitz_blog_page
		App_link( ): $mol_link
		plugins( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=blog.view.tree.d.ts.map